import React from "react";

const Count = ({ children, muted }) => (
  <span
    className={`inline-flex h-5 min-w-5 items-center justify-center rounded px-1.5 text-xs font-medium ${
      muted ? "bg-surfaceMuted text-faint" : "bg-amber-bg text-amber-text"
    }`}
  >
    {children}
  </span>
);

export default Count;
